import { SET_READONLY } from '../actions/readonly.action';

export function readonlyReducer(state: boolean = false, action: any): boolean {
    switch (action.type) {
        case SET_READONLY:
            return action.payload;
        default:
            return state;
    }
}
